//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import imagePlaceholder from '~/static/icons/product_placeholder.svg';

export default {
  name: 'SfImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    srcsets: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => item.resolution && item.src)
        || value.every((item) => item.src && item.width),
    },
    alt: {
      type: String,
      required: true,
    },
    width: {
      type: [Number, String],
      default: null,
      validator: (value) => !Number.isNaN(value),
    },
    height: {
      type: [Number, String],
      default: null,
      validator: (value) => !Number.isNaN(value),
    },
    placeholder: {
      type: String,
      default: imagePlaceholder,
    },
    loading: {
      type: String,
      default: 'lazy',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      validator: (value) => ['', 'lazy', 'eager'].includes(value),
    },
    imageTag: {
      type: String,
      default: 'img',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      validator: (value) => ['', 'img', 'nuxt-img', 'nuxt-picture'].includes(value),
    },
    nuxtImgConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    sortedSrcsets() {
      const arr = [...this.srcsets];

      arr.sort((setA, setB) => (setA.width && setB.width
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        ? Number.parseInt(setA.width, 10) - Number.parseInt(setB.width, 10)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        : Number.parseInt(setA.resolution, 10) - Number.parseInt(setB.resolution, 10)));
      return arr;
    },
    srcset() {
      if (this.sortedSrcsets.length === 0) return null;
      return this.sortedSrcsets.reduce(
        (str, set) => `${this.prefix(str)}${set.src} ${this.srcsetDescriptor(set)}`,
        '',
      );
    },
    sizes() {
      const hasBreakpoints = this.sortedSrcsets.every(
        (set) => set.breakpoint && set.width,
      );
      if (!hasBreakpoints) return null;
      return this.sortedSrcsets.reduce(
        (str, set) => `${this.prefix(str)}${this.formatBreakpoint(
          set.breakpoint,
        )}${this.formatDimension(set.width)}`,
        '',
      );
    },
    classes() {
      if (this.loaded) {
        return 'sf-image sf-image-loaded';
      }
      return 'sf-image';
    },
    imageComponentTag() {
      return !this.$nuxt ? 'img' : this.imageTag || 'img';
    },
    isPlaceholderVisible() {
      return this.loaded || (!this.loaded && !this.placeholder);
    },
    attributes() {
      return this.imageTag === 'img' || this.imageTag === ''
        ? {
          ...this.$attrs,
          sizes: this.sizes,
          srcset: this.srcset,
        }
        : {
          ...this.$attrs,
          width: this.width ? this.width : null,
          height: this.height ? this.height : null,
          ...this.nuxtImgConfig,
        };
    },
    styles() {
      if (
        !this.width
        && !this.srcset
        && (this.imageTag === 'img' || this.imageTag === '')
      ) {
        console.warn('Missing required prop width.');
      }
      if (
        !this.height
        && !this.srcset
        && (this.imageTag === 'img' || this.imageTag === '')
      ) {
        console.warn('Missing required prop height.');
      }
      const sizeHandler = (size) => (size === null ? null : `${size}px`);
      return {
        '--_image-width': sizeHandler(this.width),
        '--_image-height': sizeHandler(this.height),
      };
    },
  },
  methods: {
    onLoad() {
      this.loaded = true;
    },
    formatResolution(resolution) {
      return (`${resolution}`).endsWith('x') ? resolution : `${resolution}x`;
    },
    formatDimension(size) {
      // eslint-disable-next-line valid-typeof
      if (typeof size === null) return;
      if (
        ['%'].includes(`${size}`.slice(-1))
        || ['rem'].includes(`${size}`.slice(-3))
        || ['em', 'px', 'vw', 'vh'].includes(`${size}`.slice(-2))
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        || !Number.parseInt(size, 10)
      ) {
        // eslint-disable-next-line consistent-return
        return size;
      }
      // eslint-disable-next-line consistent-return
      return `${size}px`;
    },
    formatBreakpoint(breakpoint) {
      return breakpoint ? `(max-width: ${breakpoint}px) ` : '';
    },
    prefix(str) {
      return str ? `${str}, ` : '';
    },
    srcsetDescriptor(srcset) {
      return srcset.width
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        ? `${Number.parseInt(srcset.width, 10) || ''}w`
        : this.formatResolution(srcset.resolution);
    },
  },
};
